import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Utils } from 'src/app/core/resources/utils';
import { TransportCompany } from 'src/app/core/interfaces/transportCompany';
import { SaasTransportCompany } from 'src/app/core/interfaces/saasTransportCompany';
import { CompaniesService } from 'src/app/modules/administration/companies/list-companies.service';

export interface SelectTransportCompanyOptions {
  appearance?: 'legacy' | 'standard' | 'fill' | 'outline';
  label?: string;
  emptyOptionLabel?: string;
  disabled?: boolean;
  /**
   * Aplica el permiso transversal para cambiar la transportadora en servicios.
   * Se deja opcional porque la asociación administrativa y los filtros no usan
   * el permiso de edición de servicios.
   */
  enforceChangePermission?: boolean;
  valueMode?: 'object' | 'id';
}

@Component({
  selector: 'app-select-transport-company',
  templateUrl: './select-transport-company.component.html',
  styleUrls: ['./select-transport-company.component.scss']
})
export class SelectTransportCompanyComponent implements OnInit {
  @Input() inputFormControl: AbstractControl;
  @Input() options: SelectTransportCompanyOptions = {};

  transportCompanies: SaasTransportCompany[] = [];
  readonly permission = Permission;

  constructor(
    private companiesService: CompaniesService,
    private permissionRole: PermissionRole,
    public utils: Utils
  ) { }

  ngOnInit(): void {
    this.companiesService.getCachedSaasTransportCompanies().subscribe(
      (companies: SaasTransportCompany[]) => this.transportCompanies = companies || [],
      () => this.transportCompanies = []
    );
  }

  get appearance(): 'legacy' | 'standard' | 'fill' | 'outline' {
    return this.options.appearance || 'standard';
  }

  get label(): string {
    return this.options.label || 'Empresa de transporte';
  }

  get isRequired(): boolean {
    const validator = this.inputFormControl && this.inputFormControl.validator;
    const validationResult = validator && validator({} as AbstractControl);
    return !!(validationResult && validationResult.required);
  }

  get isDisabled(): boolean {
    return !!this.options.disabled || (
      !!this.options.enforceChangePermission && !this.hasPermissionToChangeTransportCompany
    );
  }

  private get hasPermissionToChangeTransportCompany(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.changeTransportCompany
    );
  }

  getOptionValue(company: SaasTransportCompany): string | TransportCompany {
    if (this.options.valueMode === 'id') return company.companyId;
    return { id: company.companyId, name: company.name };
  }

  compareTransportCompanies(first: TransportCompany, second: TransportCompany): boolean {
    return !!(first && second && first.id === second.id);
  }

  compareTransportCompanyIds(first: string, second: string): boolean {
    return first === second;
  }
}
